import http from './http'

export function setAuthToken(token) {
  try {
    if (token) {
      localStorage.setItem('Authorization', token)
      localStorage.setItem('token', token)
    }
  } catch { void 0 }
}

export function getAuthToken() {
  try {
    return localStorage.getItem('Authorization') || localStorage.getItem('token') || ''
  } catch {
    return ''
  }
}

export function logout() {
  try {
    localStorage.removeItem('Authorization')
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  } catch { void 0 }
}

// 登录接口：具体返回结构以后端为准，提取并保存令牌
export async function login(credentials) {
  const res = await http.post('/user/login', credentials, { skipErrorMessage: true })
  // 令牌可能在响应头或响应体中，尽量兼容
  const headerToken = res.headers?.authorization || res.headers?.Authorization
  const bodyToken = res.data?.token || res.data?.data?.token
  const token = headerToken || bodyToken || ''
  if (token) setAuthToken(token)
  return res.data
}

// 检查是否已登录（不再自动登录）
export async function ensureLoggedIn() {
  const token = getAuthToken()
  if (token && token.length > 0) {
    return token
  }
  // 没有token时返回空，由路由守卫处理跳转
  return ''
}
